import { render } from "./pay-finish.vue?vue&type=template&id=2922d278&scoped=true"
import script from "./pay-finish.vue?vue&type=script&lang=js"
export * from "./pay-finish.vue?vue&type=script&lang=js"

import "./pay-finish.vue?vue&type=style&index=0&id=2922d278&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2922d278"]])

export default __exports__